import React from "react";
import { Container, StyledChip } from "../styled/MultiSelectChip.styled";
import { IoClose } from "react-icons/io5";

export default function MultiSelectChip({ models, handleDelete, ...props }) {
  return (
    <Container>
      {models?.map((model) => {
        if (model) {
          return (
            <StyledChip
              label={model.name || model}
              onDelete={() => {
                handleDelete(model.name || model);
              }}
              variant={"outlined"}
              color={"primary"}
              deleteIcon={<IoClose />}
            />
          );
        }
      })}
    </Container>
  );
}
